//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    matrizes: Array,
    titulo: String,
  },

  data() {
    return {
      panel: 0,
      panel2: null,
    }
  },
  computed: {
    painelItems2() {
      return this.matrizes.slice(
        Math.ceil(this.matrizes.length / 2),
        this.matrizes.length
      )
    },
    disabled() {
      let hasItems = this.matrizes.map((el) => {
        return el.itens ? !!el.itens.length : false
      })
      return !hasItems.find((a) => a === true)
    },
  },
  mounted() {
    this.panel2 = this.painelItems2.length - 1
  },
}
